module.exports = __webpack_public_path__ + "static/media/iconmonstr-linkedin-rounded.5b238434.svg";